<div *ngIf="!loading" class="chronology-container">
    <div class="chronology-container-slider">
        <app-slider-horizontal
                [elements]="sortedArticles"
                [grid]="1"
                [step]="4"
                [backgroundContain]="false"
                (emitActive)="getActive($event)"
        />
    </div>
    <div class="chronology-container-timeline">
        <app-timeline [activeYear]="0"
                      [activeMonth]="1"
                      (rightSwipe)="swipe('right')"
                      (leftSwipe)="swipe('left')"
                      (emitActive)="setActiveByTimeline($event)"/>
    </div>
</div>
